import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.paddings(20, 20, 0),
  backgroundColor: theme.palette.white,
}));